function Card({ children, className = '' }) {
  return (
    <div
      className={`rounded-3xl border border-[#dfd1c4] bg-white shadow-[0_14px_34px_rgba(69,48,33,0.09)] ${className}`.trim()}
    >
      {children}
    </div>
  );
}

export default Card;
